const PERSONAL_PREFIX = "personal:"

function trimAgentId(agentId) {
  return typeof agentId === "string" ? agentId.trim() : ""
}

function aliasCandidates(agentId) {
  const trimmed = trimAgentId(agentId)
  if (!trimmed) {
    return []
  }

  const candidates = [trimmed]
  const lower = trimmed.toLowerCase()
  if (lower.startsWith(PERSONAL_PREFIX)) {
    candidates.push(trimmed.slice(PERSONAL_PREFIX.length))
  } else if (!trimmed.includes(":")) {
    candidates.push(`${PERSONAL_PREFIX}${trimmed}`)
  }

  return Array.from(new Set(candidates.filter(Boolean)))
}

export function normalizeComparableAgentId(agentId) {
  const trimmed = trimAgentId(agentId)
  if (!trimmed) {
    return null
  }

  const lower = trimmed.toLowerCase()
  if (lower.startsWith(PERSONAL_PREFIX) || lower.startsWith("default:")) {
    return lower
  }
  if (lower.includes(":")) {
    return lower
  }
  return `${PERSONAL_PREFIX}${lower}`
}

export function areEquivalentAgentIds(left, right) {
  const normalizedLeft = normalizeComparableAgentId(left)
  const normalizedRight = normalizeComparableAgentId(right)
  return Boolean(normalizedLeft && normalizedRight && normalizedLeft === normalizedRight)
}

export function findWorldAgentById(agentId, agents = []) {
  const comparableAgentId = normalizeComparableAgentId(agentId)
  if (!comparableAgentId) {
    return null
  }

  return (
    agents.find((agent) => {
      const candidates = [
        ...aliasCandidates(agent?.id),
        ...aliasCandidates(agent?.openclawAgentId),
      ]
      return candidates.some((candidate) => areEquivalentAgentIds(candidate, comparableAgentId))
    }) || null
  )
}

export function resolveWorldAgentId(agentId, agents = []) {
  return findWorldAgentById(agentId, agents)?.id || trimAgentId(agentId) || null
}
